/*** Load GSAP plugins - enable and comment out only gsap plugins needed ***/

/*if(window.unboxSettings?.gsapEnabled ) {
	function whenGSAPReady(cb, tries = 120) { // up to ~6s @ 50ms
		if (window.gsap && window.ScrollTrigger){
			//check GSAP and ScrollTrigger loaded from base theme
			return cb(window.gsap); //when GSAP and ScrollTrigger are loaded, call the callback function, passed to whenGSAPReady below, with the GSAP instance
		}
        if (tries <= 0) return;
        setTimeout(() => whenGSAPReady(cb, tries - 1), 50);
    }

    //import plugins and when loaded, set flag so can be used
	// Calling whenGSAPReady with the entire arrow function below: 
    whenGSAPReady(async (gsap) => {
		try {
          // MotionPathPlugin is INCLUDED in the public gsap npm package
          const { default: MotionPathPlugin } = await import('gsap/MotionPathPlugin');
          gsap.registerPlugin(MotionPathPlugin);
        } catch (e) {
          console.warn('MotionPathPlugin not loaded:', e);
        }
      
        try {
          // DrawSVGPlugin is INCLUDED in the public gsap npm package
          const { default: DrawSVGPlugin } = await import('gsap/DrawSVGPlugin');
          gsap.registerPlugin(DrawSVGPlugin);
        } catch (e) {
          // This will happen if you don’t have DrawSVG available.
          console.warn('DrawSVGPlugin unavailable (expected if not licensed/added):', e?.message || e);
        }

		try {
			// SplitText is a utility class, not a traditional plugin
			const SplitTextModule = await import('gsap/SplitText');
			const SplitText = SplitTextModule.SplitText || SplitTextModule.default;
			
			if (SplitText && typeof SplitText === 'function') {
				// SplitText doesn't need to be registered as a plugin - it's a utility class
				// Make it available globally for use
				window.SplitText = SplitText;
			} else {
				console.error('SplitText not found or not a function:', SplitText);
			}
		} catch (e) {
			console.error('SplitText failed to load:', e);
		}
    });

    (function check() {
		
        if (!window.gsap || !window.gsap.plugins?.drawSVG || !window.gsap.plugins?.motionPath || !window.SplitText || !window.ScrollTrigger){
			return setTimeout(check, 50);			
		} 

		const { gsap, ScrollTrigger, SplitText } = window;
		const { drawSVG, motionPath } = gsap.plugins;

		//Put GSAP code here

	})(); // <-- This immediately executes the function

}
	*/




// Smooth scroll for anchor links
/*
Tested on BrokerPRO
if (window.location.hash) {
	// Remove the hash temporarily to prevent default jump
	const hash = window.location.hash;
	//history.replaceState(null, null, ' ');
	
	// Wait for page to fully load, then scroll
	window.addEventListener('load', () => {
		const element = document.querySelector(hash);
		if (element) {
			const header = document.querySelector('header');
			let scrollSpacer = 300;
			if(header){
				scrollSpacer = header.offsetHeight + 100;
			}

			const rect = element.getBoundingClientRect();
			const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
			const targetPosition = rect.top + scrollTop;
			
			window.scrollTo({
				top: targetPosition - scrollSpacer,
				behavior: 'smooth'
			});
		}
	});
}

//If link going to anchor on same page, add an onclick to smooth scroll to the anchor
const anchorLinks = document.querySelectorAll('a[href*="#"]');
anchorLinks.forEach(link => {
	link.addEventListener('click', function(e) {
		//only looking for links within the same page
		if(link.getAttribute('href') !== '#' &&e.target.pathname === window.location.pathname && e.target.hostname === window.location.hostname){        
			const targetId = link.hash.substring(1);
			if(targetId){
				const targetElement = document.getElementById(targetId);
			
				if (targetElement) {
					e.preventDefault();
					// Get the header height if it exists (adjust selector as needed)
					const header = document.querySelector('header');
					let scrollSpacer = 300;
					if(header){
						scrollSpacer = header.offsetHeight + 100;
					}
					const rect = targetElement.getBoundingClientRect();
					const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
					const targetPosition = rect.top + scrollTop;
					
					// Smooth scroll to the target
					window.scrollTo({
						top:  targetPosition - scrollSpacer,
						behavior: 'smooth'
					});
					
					// Update URL so gets hash (e.preventDefault() stops this from happening)
					history.pushState(null, null, '#' + targetId);
				}
			}
		}
	});
}); */

